import Avatar from './Avatar';
import Preview from './Preview';


const AvatarsContainer = ({
  visibleParticipants,
  videoLayout,
  participanteLocal,
  noRenderizarParticipanteLocal,
  esLayoutMobile,
  deberiaEstarEnSalaEspera,
  tieneViewportPocaAltura
}) => {

  return (
    <>
      {visibleParticipants.map((user, index) => {
        if (index > videoLayout.length - 1) {
          return null;
        }

        // como estamos iterando sobre todos los usuarios, queremos
        // saber si justo este es el participante local para
        // no renderizarlo
        const esAvatarParticipanteLocal =
          participanteLocal?.userId === user.userId;
        if (noRenderizarParticipanteLocal && esAvatarParticipanteLocal) {
          return null;
        }

        const dimension = videoLayout[index];
        const { width, height, x, y } = dimension;
        const posicionTop =
          esLayoutMobile && deberiaEstarEnSalaEspera
            ? `${y + 70}px`
            : `${y}px`;

        return (
          <div key={user.userId}>
            <Avatar
              participant={user}
              style={{
                width: `${width}px`,
                height: `${height}px`,
                top: posicionTop,
                left: `${x}px`,
              }}
              tieneViewportPocaAltura={tieneViewportPocaAltura}
              esParticipanteLocal={
                participanteLocal?.userId === user.userId
              }
            />

            {!esLayoutMobile && deberiaEstarEnSalaEspera && <Preview />}
          </div>
        );
      })}
    </>
  )
}

export default AvatarsContainer;